
import { useAppStore } from '@/stores/appStore'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: types exist in node_modules but current moduleResolution prevents resolving them; adjust tsconfig if preferred
import Keycloak, { type KeycloakProfile } from 'keycloak-js'
import dayjs from 'dayjs'

const keycloak = new Keycloak({
  url: 'https://auth.ool.pt',
  realm: 'gorate',
  clientId: 'gorate-banco-montepio'
})

export const login = async () => {
  try {
    const appStore = useAppStore()
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      redirectUri: window.location.href
    })

    if (authenticated) {
      console.log('User is authenticated')
      const userProfile: KeycloakProfile = await keycloak.loadUserProfile()
      appStore.setSession(keycloak.token, userProfile)
      return true
    } else {
      console.log('User is not authenticated')
      appStore.clearSession()
      return false
    }
  } catch (error) {
    console.error('Failed to initialize adapter:', error)
  }
}

export const logout = async () => {
  const appStore = useAppStore()
  await keycloak.logout({
    redirectUri: window.location.href
  })

  appStore.clearSession()
  return true
}

export const refreshTokenPair = async (): Promise<void> => {
  try {
    const appStore = useAppStore()
    const refreshed = await keycloak.updateToken(70) // se o token expirar dentro de 70 segundos, faz refresh
    if (refreshed) {
      appStore.setSession(keycloak.token)
      console.log('Access token successfully refreshed.')
    } else {
      const now = dayjs().unix()
      const accessTokenExp = keycloak.tokenParsed?.exp ?? 0
      const refreshTokenExp = keycloak.refreshTokenParsed?.exp ?? 0

      const accessTokenSecsLeft = accessTokenExp - now
      const refreshTokenSecsLeft = refreshTokenExp - now

      console.log(`Access token will expire in ${accessTokenSecsLeft}s and refresh in ${refreshTokenSecsLeft}s.`)
    }
  } catch (error) {
    console.log('Failed to refresh access token: ', error)
  }
}
